import { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import styled from 'styled-components';
import { useDenominaciones } from '../../../../appStore/denominaciones';

const CenterdTd = styled.td`
  text-align: center;
  vertical-align: middle !important;
`;

export const InscripcionForm = ({ requisitos, setRequisitos }: any) => {
  const { requisitosPublicos }: { requisitosPublicos: any } = useDenominaciones();
  useEffect(() => {
    if (requisitosPublicos?.length !== Object.keys(requisitos).length) {
      const newValues: any = {};
      requisitosPublicos?.forEach(({ idRequisitoPuesto }: any) => {
        newValues[`${idRequisitoPuesto}`] = true;
      });
      setRequisitos(newValues);
    }
  }, [requisitosPublicos]);

  if (!requisitosPublicos) return null;

  return (
    <>
      <Table>
        <thead>
          <tr>
            <th className="font-weight-bold">
              Declaro bajo juramento cumplir con los siguientes requisitos:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={3}>
              {requisitosPublicos.length === 0 && <p>No se cargaron requisitos para este puesto</p>}
            </td>
          </tr>
          {requisitosPublicos.map(
            ({ idRequisitoPuesto, excluyente, descripcion, requerido, nombre }: any) => (
              <tr key={idRequisitoPuesto}>
                <td>
                  <span className="font-weight-bold">{nombre}</span> {descripcion}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </Table>
    </>
  );
};
